<template>
  <Card v-if="loaded" :padding="0">
    <p slot="title">Специальности</p>
    <a slot="extra" v-on:click="handleAdd">
      Добавить
    </a>
    <Modal
      :mask-closable="false"
      title="Специальность"
      v-model="modal"
      :loading="saving"
      v-on:on-ok="handleSave"
      v-on:on-visible-change="handleVisibleChange"
    >
      <Form
        ref="form"
        :model="model"
        :rules="rules"
      >
        <FormItem label="Код" prop="code">
          <Input v-model="model.code"/>
        </FormItem>
        <FormItem label="Наименование" prop="name">
          <Input v-model="model.name"/>
        </FormItem>
        <FormItem label="Срок обучения" prop="duration">
          <Input v-model="model.duration"/>
        </FormItem>
        <FormItem label="Стоимость обучения" prop="price">
          <Input v-model="model.price"/>
        </FormItem>
        <FormItem label="Ученая степень" prop="degree">
          <Input v-model="model.degree" placeholder="Магистратура"/>
        </FormItem>
        <FormItem label="Колличество грантных мест" prop="grants">
          <Input v-model="model.grants"/>
        </FormItem>
        <FormItem 
          v-for="(item, index) in model.documents"
          :label="'Обязательный документ ' + (index + 1)"
          :key="item.id"
          :prop="'documents.' + index + '.title'"
          :rules="{required: true, message: ' ', pattern: /([^\s])/}"
        >
          <div class="inline-block">
            <div class="deletable-item">
              <Input v-model="item.title"/>
              <Icon
                class="trash"
                type="md-trash"
                :size="18"
                v-on:click="() => handleDocumentDelete(index)"
              />
            </div>
          </div>
        </FormItem>
        <div class="inline-block">
          <Button v-on:click="handleDocumentAdd">
            Добавить обязательный документ
          </Button>
        </div>
      </Form>
    </Modal>

    <div class="search-container">
      <Input
        search
        enter-button
        placeholder="Поиск"
        v-on:on-search="handleSearch"
      />
    </div>
    <div>
      <div
        class="element"
        v-for="(element, index) in elements"
        :key="element.id"
      >
        <div class="info">
          <p><b>Код</b>: {{ element.code }}</p>
          <p><b>Наименование</b>: {{ element.name }}</p>
          <p><b>Срок обучения</b>: {{ element.duration }}</p>
          <p><b>Стоимость обучения</b>: {{ element.price }}</p>
          <p v-if="!!element.degree">
            <b>Ученая степень</b>: {{ element.degree }}
          </p>
          <p v-if="!!element.grants">
            <b>Колличество грантных мест</b>: {{ element.grants }}
          </p>
          <p v-if="element.documents">
            <b>Обязательные документы</b>: 
            {{ element.documents.map(e => e.title).join(', ') }}
          </p>
        </div>
        <div class="icons-container">
          <Icon 
            class="icon"
            type="md-create"
            size="20"
            v-on:click="() => handleEdit(element, index)"
          />
          <Icon 
            class="icon" 
            type="md-trash" 
            size="20"
            v-on:click="() => handleDelete(element, index)"
          />
        </div>
      </div>
    </div>
  </Card>
  <Spin v-else size="large" fix/>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/database';

export default {
  data() {
    return {
      id: null,
      institution: null,
      loaded: false,
      modal: false,
      saving: true,
      model: {
        code: "",
        name: "",
        price: "",
        duration: "",
        grants: "",
        degree: "",
        documents: []
      },
      rules: {
        code: [{ required: true, message: ' ', pattern: /([^\s])/ }],
        name: [{ required: true, message: ' ', pattern: /([^\s])/ }],
        duration: [{ required: true, message: ' ', pattern: /([^\s])/ }],
        price: [{ required: true, message: ' ', pattern: /([^\s])/ }],
        degree: [{ required: false, message: ' ', pattern: /([^\s])/ }],
        grants: [{ required: false, message: ' ', pattern: /([^\s])/ }],
      },
      data: [],
      elements: []
    }
  },
  async mounted() {
    const email = firebase.auth().currentUser.email;

    const ref = firebase.database().ref(`institutions`)
    .orderByChild('admin').equalTo(email);
    const snapshot = await ref.once('value');
    const array = [];
    
    snapshot.forEach(childSnapshot => {
      const element = childSnapshot.val();
      element.id = childSnapshot.key;
      array.push(element);
    });

    if(array.length > 0) {
      const institution = array[0];

      if(!institution.active) {
        await firebase.auth().signOut();

        this.$router.push('/auth');
      }

      this.institution = institution.id;

      try {
        const ref = firebase.database().ref(`specialties/${this.institution}`);
        const snapshot = await ref.once('value');
        const array = [];

        snapshot.forEach(childSnapshot => {
          const element = childSnapshot.val();
          element.id = childSnapshot.key;
          array.push(element);
        });

        this.data = array;
        this.elements = array;
      }
      catch(error) {

      }
    }

    this.loaded = true;
  },
  methods: {
    handleSearch(value) {
      const target = value.toLowerCase();

      this.elements = this.data.filter(e => {
        const name = e.name.toLowerCase();

        return (name.startsWith(target));
      });
    },
    handleAdd() {
      this.modal = true;
    },
    handleDocumentAdd() {
      if(!this.model.documents) this.model.documents = [];

      this.model.documents.push({ title: null });
    },
    handleDocumentDelete(index) {
      this.$Modal.confirm({
        title: 'Удаление',
        content: 'Вы уверены, что хотите удалить?',
        onOk: () => this.model.documents.splice(index, 1)
      });
    },
    async handleDelete(item, index) {
      this.$Modal.confirm({
        title: 'Удаление',
        content: 'Вы уверены, что хотите удалить?',
        loading: true,
        onOk: async () => {
          const path = `specialties/${this.institution}/${item.id}`;
          await firebase.database().ref(path).remove();

          this.elements.splice(index, 1);

          this.$Modal.remove();
        }
      });
    },
    handleEdit(item, index) {
      this.id = item.id;

      this.model = {
        code: item.code,
        name: item.name,
        price: item.price,
        duration: item.duration,
        grants: item.grants,
        degree: item.degree,
        documents: item.documents
      };

      this.modal = true;
    },
    handleVisibleChange(value) {
      if(!value) {
        setTimeout(() => {
          this.$refs.form.resetFields()
          this.model.documents = [];
        }, 300);
      }
    },
    async handleSave() {
      const valid = await new Promise(
        resolve => this.$refs.form.validate(valid => resolve(valid))
      );

      if(!valid) {
        this.$Message.error("Необходимо заполнить поля");
        this.saving = false;
        await this.$nextTick();
        this.saving = true;
        return;
      }

      await this.save();
    },
    async save() {
      try {
        const ref = !!this.id ? 
        firebase.database().ref(`specialties/${this.institution}/${this.id}`) :
        firebase.database().ref(`specialties/${this.institution}`).push();

        const data = {
          code: this.model.code,
          name: this.model.name,
          price: this.model.price,
          duration: this.model.duration,
          grants: this.model.grants,
          degree: this.model.degree,
          documents: this.model.documents.map(e => ({
            title: e.title
          }))
        };

        await ref.set(data);

        data.id = ref.key;

        if(this.id) {
          const index = this.elements.findIndex(e => e.id === this.id);
          this.$set(this.elements, index, data);
          this.id = null;
        }
        else {
          this.elements.push(data);
        }

        this.$Message.success("Успешно сохранено");

        this.modal = false;
      }
      catch(error) {
        console.log(error);
        
        this.$Message.error("Ошибка");

        this.saving = false;
        await this.$nextTick();
        this.saving = true;
      }
    }
  }
}
</script>

<style scoped>
.root {
  width: 100%;
  height: 100%;
}
.element:first-child {
  padding-top: 0;
}
.element {
  padding: 16px;
  border-bottom: 1px solid #e8eaec;
}
.element {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.element .info {
  line-height: 2;
}
.icons-container {
  margin-left: 8px;
  min-width: 56px;
}
.icon {
  cursor: pointer;
  margin: 4px;
}
.inline-block {
  width: 100%; 
  display: inline-block;
}
.deletable-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.trash {
  cursor: pointer;
  padding-left: 10px;
  padding-right: 4px;
}
.search-container {
  padding: 16px;
}
</style>